import { useCallback } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import FigmaBox from '../../mynt-components/components/FigmaBox'
import { FRAUD_CASES_PATH } from '../../routes/constants'
import { FraudCasesPage } from './components/FraudCasesPage'

export const FraudCasesAdapter = () => {
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const caseId = searchParams.get('caseId') ?? undefined
  const onReset = useCallback(() => navigate(FRAUD_CASES_PATH), [navigate])

  return (
    <FigmaBox top="40px" fullWidth>
      <FraudCasesPage key={caseId ?? 'list'} caseId={caseId} onReset={caseId ? onReset : undefined} />
    </FigmaBox>
  )
}

export default FraudCasesAdapter
